// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-17e0e0ee]{font-family:\"Lettera Text LL\",Helvetica,Arial,sans-serif;font-size:1.6rem;margin:20px 0 0;text-align:center}@media print,screen and (min-width:769px){.title[data-v-17e0e0ee]{font-size:2.5rem;margin:50px 0}}.subtitle[data-v-17e0e0ee]{color:#4b5061;line-height:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
